import {Component} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {DocumentoPac} from "src/app/model/DocumentoPac";
import {ParamAditivo} from "src/app/model/ParamAditivo";
import {ResultadoEnvioAditivo} from "src/app/model/ResultadoEnvioAditivo";
import {PacService} from "src/app/services/pac.service";
import {AditivoService} from "src/app/services/aditivo.service";
import {SrfService} from "src/app/services/srf.service";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import {Receita} from "src/app/model/Receita";
import {Cnae} from "src/app/model/Cnae";
import {Municipio} from "src/app/model/Municipio";
import {erro, Erro} from "src/app/model/Erro";
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {formatDate} from "@angular/common";

//import { toJSDate } from "@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar";

@Component({
  selector: 'envio-aditivo',
  templateUrl: './envio-aditivo.component.html',
  styleUrls: ['./envio-aditivo.component.scss'],
  standalone: false
})
export class EnvioAditivoComponent {

  pac: DocumentoPac;
  comprador: String;
  compradorNome: String;
  compradorCnae: Cnae;
  resultadoEnvioAditivo: ResultadoEnvioAditivo;
  erros: Erro[];

  podeAditar: boolean;

  param: ParamAditivo;

  // Campos Aditivo
  cnpjCpf: string;
  cnpjCpfChanged: Subject<string> = new Subject<string>();

  tipoPessoaFisicaJuridica: string
  caractCapitalSocial: number;
  indAtividadeDecreto: boolean;
  porteEmpresa: number;
  rob: Receita;
  cnpjLiderGrupo: string;
  robGrupo: Receita;
  municipioInstalacao: Municipio;
  cnaeInvestimento: Cnae;
  cnpjInvestimento: string;
  comentario: string;

  constructor(
    private pacService: PacService,
    private aditivoService: AditivoService,
    private srfService: SrfService,
    private route: ActivatedRoute,
    private alertService: BnAlertsService
  ) {
    this.cnpjCpfChanged.pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe(model => {
        this.cnpjCpf = model;
        this.buscarNomeComprador();
      })

    this.rob = new Receita();
    this.robGrupo = new Receita();
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(
      m => {
        const id = m.get('id');
        this.pacService.obterPac(id).subscribe(
          p => {
            this.pac = p;
            this.resetParamAditivo();
          },
          error => {
            console.log('Houve erro ao obter a PAC ' + id+ '. ');
            console.debug(error);
            this.alertService.alertaErro('Erro', 'Houve erro ao obter a PAC ' + id + '.');
          }
        );
        this.podeAditar = null;
        this.pacService.pacComOperacaoAtiva(id).subscribe(
          r => {
            console.log('PAC ' + id + ' de operação ativa? ' + r.podeAditar);
            this.podeAditar = r.podeAditar;
          },
          error => {
            console.log('Houve erro ao verificar se a PAC ' + id + ' está relacionada a uma operação ativa. ');
            console.debug(error);
            this.alertService.alertaErro('Erro', 'Houve erro ao verificar situação da operação associada à PAC ' + id + '.');
          }
        );
      }
    )
  }

  onMudaComprador(numDoc: string) {
    this.cnpjCpfChanged.next(numDoc);
  }

  onEnviarAditivo() {
    if (this.existeErroPreenchimento()) {
      return;
    }
    this.erros = null;
    const param = new ParamAditivo();
    param.idePac = this.pac.id;
    param.comentario = this.comentario;
//    param.tipoPessoaFisicaJuridica = (this.cnpjCpf < 100000000000) ? 'FISICA' : 'JURIDICA';
    param.tipoPessoaFisicaJuridica = this.tipoPessoaFisicaJuridica;
    param.cnpjCpf = this.cnpjCpf;
    param.cnaeComprador = this.compradorCnae?.codigo;
    param.caractCapitalSocial = (this.caractCapitalSocial > 0) ? this.caractCapitalSocial : null;
    param.indAtividadeDecreto = this.indAtividadeDecreto;
    param.porteEmpresa = String(this.porteEmpresa);
    param.rob = this.rob.orNull();
    param.cnpjLiderGrupo = this.cnpjLiderGrupo;
    param.robGrupo = this.robGrupo.orNull();
    if (this.municipioInstalacao) {
      param.codMunicipioInstalacao = Number(this.municipioInstalacao.id);
    }
    param.cnaeInvestimento = this.cnaeInvestimento?.codigo;
    param.cnpjInvestimento = this.cnpjInvestimento;

    this.param = param;

    this.aditivoService.enviarAditivo(param).subscribe(
      resp => {
        this.resultadoEnvioAditivo = resp;

        if (resp.erros.length == 0) {
          this.alertService.alertaSucesso('', 'Aditivo enviado com sucesso (' + resp.ideAditivo + ').');
        } else {
          this.erros = resp.erros;
          this.alertService.alertaErro('Erro', 'Houve erros ao enviar o aditivo.');
        }
      },
      error => {
        this.resultadoEnvioAditivo = error;
      }
    );
  }

  podeSubmeterAditivo() {
    return this.podeAditar !== null && this.podeAditar;
  }

  private existeErroPreenchimento(): boolean {
    function data(data: Date): string {
      return formatDate(data, 'dd/MM/yyyy', 'en-US') // Erro ao tentar usar pt-BR
    }

    // console.log("tipo")
    // console.log(this.rob.tipo);
    // console.log(this.robGrupo.tipo);
    if (this.rob.tipo == "null") this.rob.tipo = null;
    if (this.robGrupo.tipo == "null") this.robGrupo.tipo = null;

    let erros = [];
    const hoje = new Date();
    //hoje.setHours(0,0,0,0);

    if (this.cnpjCpf == this.pac.compradorCnpjCpf) {
      erros.push(erro("O beneficiário não foi alterado, o CNPJ/CPF deve ser diferente de " + this.pac.compradorCnpjCpf + "."));
    }
    if (this.rob.tipo == 'E' && this.rob.dataReferencia > hoje) {
      erros.push(erro("Data de Referência (" + data(this.rob.dataReferencia)+") da ROB efetiva da Beneficiária não pode ser maior que hoje."));
    }
    if (this.robGrupo.tipo == 'E' && this.robGrupo.dataReferencia > hoje) {
      erros.push(erro("Data de Referência (" + data(this.robGrupo.dataReferencia)+") da ROB efetiva do Grupo Econômico não pode ser maior que hoje."));
    }

    if ((!this.rob.tipo) && (this.rob.dataReferencia || this.rob.valor)) {
        erros.push(erro("Tipo da receita da beneficiária não informada, enquanto há informações de data e/ou valor."));
    }

    if ((this.rob.tipo) && (!this.rob.dataReferencia || !this.rob.valor)) {
        erros.push(erro("Ao informar a ROB da beneficiária é necessário informar também seu valor e data de referência."));
    }

    if ((!this.robGrupo.tipo) && (this.robGrupo.dataReferencia || this.robGrupo.valor)) {
      erros.push(erro("Tipo da receita do grupo econômico não informada, enquanto há informações de data e/ou valor."));
    }

    if ((this.robGrupo.tipo) && (!this.robGrupo.dataReferencia || !this.robGrupo.valor)) {
      erros.push(erro("Ao informar a ROB do Grupo Econômico é necessário informar também seu valor e data de referência."));
    }

    if (erros.length !== 0) {
      this.erros = erros;
      return true;
    }
    return false;
  }

  buscarNomeComprador(): void {
    if (this.cnpjCpf) {
      this.srfService.obterNomePessoaFJ(this.cnpjCpf).subscribe(
        p => {
          this.compradorNome = p.nome;
          this.tipoPessoaFisicaJuridica = p.tipo;
        },
        error => {
          console.log('Houve erro ao obter o nome de ' + this.cnpjCpf + '. ' + error.message);
          console.debug(error);
          this.alertService.alertaErro('Erro', 'Houve erro ao obter o nome de ' + this.cnpjCpf + '.');
        }
      );
    }
  }

  ehPessoaFisica(): boolean {
    return 'FISICA' === this.tipoPessoaFisicaJuridica;
  }

  resetParamAditivo(): void {
    this.compradorNome = this.pac.compradorNome;
    this.comentario = '';
    this.cnpjCpf = this.pac.compradorCnpjCpf;
    this.compradorCnae = new Cnae();
    this.caractCapitalSocial = this.pac.compradorCapitalSocialId;
    this.indAtividadeDecreto = this.pac.compradorIndAtividadeDecreto;
    this.porteEmpresa = this.pac.compradorPorteId;
    this.rob = new Receita();
    this.rob.tipo = this.pac.compradorRobTipo;
    this.rob.valor = this.pac.compradorRobValor;
    this.rob.dataReferencia = this.pac.compradorRobData;
    this.cnpjLiderGrupo = this.pac.grupoCnpjLider;
    this.robGrupo = new Receita();
    this.robGrupo.tipo = this.pac.grupoRobTipo;
    this.robGrupo.valor = this.pac.grupoRobValor;
    this.robGrupo.dataReferencia = this.pac.grupoRobData;
    this.municipioInstalacao = new Municipio();
    this.municipioInstalacao.id = String(this.pac.municipioInstalId);
    this.municipioInstalacao.nome = this.pac.municipioInstalNome;
    this.municipioInstalacao.nomeCompleto = this.pac.municipioInstalNome + '/' + this.pac.municipioInstalUf;
    this.municipioInstalacao.sigla = this.pac.municipioInstalUf;
    this.cnaeInvestimento = new Cnae();
    this.cnaeInvestimento.codigo = this.pac.investimentoCnae;
    this.cnaeInvestimento.descricao = this.pac.investimentoCnaeNome;
    this.cnpjInvestimento = this.pac.investimentoCnpj;
  }
}

function copiaReceitaAcertandoTipo(receita: Receita): Receita {
  //TODO: Acertar quando o endpoint passar a aceitar receber E e P e não apenas o nome do Enum...
  const r = Object.assign(new Receita, receita);
  if (r.tipo == 'E') {
    r.tipo = 'EFETIVO';
  } else if (r.tipo == 'P') {
    r.tipo = 'PREVISTO';
  }
  return r;
}

